import { useState, useRef } from 'react'
import { useFrame } from '@react-three/fiber'
import { Points, PointMaterial, useTexture, Environment } from '@react-three/drei'
import * as random from 'maath/random/dist/maath-random.esm'
import { CameraControls } from './CameraControls'

export const Stars = ({setPlay, currentTrack, onStarClick, nextTrack, max, ...rest}) => {
  const ref = useRef()
  const [sphere] = useState(() => random.inSphere(new Float32Array(6000), { radius: 3}))
  /* const [labelX, setLabelX] = useState(0)
  const [labelY, setLabelY] = useState(0) */
  
  useFrame((state, delta) => {
      //let label = document.getElementById('label')
      ref.current.rotation.x -= delta  / 285
      ref.current.rotation.y -= delta / 275
      ref.current.rotation.z -= delta  / 100
      /* if (label) {
        setLabelX(el => el -= delta * 0.285 )
        setLabelY(el => el += delta * 0.275)
        label.style.left = labelX + 'px'
        label.style.top  = labelY + 'px'
      } */
    
  })


  const create = (event) => {
    event.stopPropagation()
    setPlay(true)
    onStarClick(nextTrack)

  /*   let label = document.getElementById('label')
    if (label) {
      document.body.removeChild(label)
    } 
    
    setLabelX(event.clientX)
    setLabelY(event.clientY)

    label = document.createElement('p')
    label.id = 'label'
    label.innerHTML = "" + currentTrack?.artist
    label.style.position = 'fixed'
    label.style.left     = event.clientX + 'px'
    label.style.top      = event.clientY + 'px'
    document.body.appendChild(label) */
  }

/*   useEffect(() => {
    let label = document.getElementById('label')
    if (label)  label.innerHTML = "" + currentTrack?.artist
  }, [currentTrack]) */

  const [ starTexture1 ] = useTexture(["https://i.ibb.co/F8by6wW/p2-b3gnym.png","https://i.ibb.co/yYS2yx5/p3-ttfn70.png"])

  return (
    <>
      <Points onClick={create} ref={ref} positions={sphere} stride={3} {...rest}>
        <Environment files={'360_F_479860143_RzIv3lrrh36LTXndeBqSSML4lqMye5RA.hdr'}  ground={{ height: 5, radius: 40, scale: 20 }}/>
        <PointMaterial transparent map={starTexture1} size={0.06}/>
        <CameraControls />
      </Points>
    </>
  )
}
